import confirm from '@touchnet/react-confirm-modal';

export type ConfirmationHandler = (e: Event, ...rest: unknown[]) => void;
export type ConfirmationBailHandler = (e: Event, ...rest: unknown[]) => boolean;

export interface ConfirmationHandlers {
    success?: ConfirmationHandler;
    failure?: ConfirmationHandler;
}

export const useConfirmation = (
    message: string = '',
    handlers: ConfirmationHandlers = null,
    bail: ConfirmationBailHandler = () => false
) => {

    return (e, ...restProps) => {
        e.preventDefault();
        e.stopPropagation();

        if (bail(e, ...restProps)) {
            return;
        }

        confirm({
            cancelLabel: 'Never mind',
            children: message,
            okLabel: 'Yes, I\'m sure',
            title: 'Are you sure?',
        }).then(
            () => handlers?.success?.(e, ...restProps),
            () => handlers?.failure?.(e, ...restProps)
        );
    };
};

export default useConfirmation;
